import { render } from "./BaseReportParametres.vue?vue&type=template&id=29644a84"
import script from "./BaseReportParametres.vue?vue&type=script&lang=js"
export * from "./BaseReportParametres.vue?vue&type=script&lang=js"

import "./BaseReportParametres.vue?vue&type=style&index=0&id=29644a84&lang=css"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__